// eslint-disable-next-line import/named
import { useHistory } from "react-router-dom";
// import { signCharterForUser, } from "../../Hooks/useDataUsersApi";
import { useState } from "react";
import { CharterDocumentation } from "../../components/charterDocument/charterDocument";
import { useOktaAuth } from "@okta/okta-react";
import { signCharterForUser } from "../../Hooks/useDataUsersApi";

/**
 * @function Sign the charter and put the user's email in the localStorage of the navigator
 * @returns {void} void
 */
/*
function Sign(user: User | null | undefined, navigate: NavigateFunction) {

    const isSigned = useDataApiSign(user as User)
    return isSigned ? navigate("/") : navigate("/charte");
    
}*/

const Sign: React.FC<object> = () => {
  // const navigate = useNavigate();
  const [change, setChange] = useState(true);
  const { authState } = useOktaAuth();
  const history = useHistory();
  if (!authState || !authState.isAuthenticated) {
    // L'utilisateur n'est pas authentifié
    return <div>Chargement...</div>;
  }

  const token = authState.idToken!.idToken

  /* when the check button is checked we enable the sign button */
  const EnableButton = () => {
    setChange(!change);
  };
  const classNameString = change ? "bg-gray-400 text-gray-900  cursor-not-allowed py-2 px-4 rounded w-full" : "bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded w-full";
  // eslint-disable-next-line unicorn/consistent-function-scoping
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    
    // Immediately call the async function without returning its promise
    // eslint-disable-next-line @typescript-eslint/require-await
    void (async () => {
      // Assuming `user` is already defined in your component's scope
      const SIGN = await signCharterForUser(token);
      
      if (SIGN) {
        history.push("/");
      } else {
        history.push("/charte");
      }
      location.reload();
    })();
  };

  return (

    <>
    <h1 className="text-red font-bold">La Charte a été modifiée, merci de la signer à nouveau</h1>
    <br></br>
     <CharterDocumentation />
      <div className="signature">
        <form onSubmit={handleSubmit}>
          <div>
            <input id="checkboxSignature" type="checkbox" onChange={EnableButton} />
            <label htmlFor="checkboxSignature"> J'accepte la charte</label>
          </div>

          <button className={classNameString} type="submit" value="Signer" disabled={change}>Signer</button>
        </form>
      </div>
    </>


  );
};

export { Sign };